import { render } from "./Onboarding.vue.js?vue&type=template&id=2b2203f9!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Onboarding.vue?vue&type=template&id=2b2203f9"
import script from "./Onboarding.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Onboarding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/onboarding/Onboarding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b2203f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b2203f9', __exports__)) {
    api.reload('2b2203f9', __exports__)
  }
  
  module.hot.accept("./Onboarding.vue.js?vue&type=template&id=2b2203f9!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Onboarding.vue?vue&type=template&id=2b2203f9", () => {
    api.rerender('2b2203f9', render)
  })

}


export default __exports__